"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import e from "../components/Icon/SvgIcon.js";
const t = (l) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.5 11H13V2.5c0-.276-.21-.5-.47-.5h-1.06c-.26 0-.47.225-.47.5V11H2.5c-.276 0-.5.21-.5.47v1.06c0 .26.225.47.5.47H11v8.5c0 .276.21.5.47.5h1.06c.26 0 .47-.223.47-.5V13h8.5c.276 0 .5-.211.5-.471v-1.06c0-.259-.223-.47-.5-.47",
        clipRule: "evenodd"
      }
    )
  }
), n = c(t);
export {
  n as Plus,
  n as default
};
